<template>
  <section class="custom-record">
    <div class="custom-header">
      <span>Details</span>
      <div class="custom-close">
        <div class="custom-close-button" @click="closeDetails">
          <i class="fa fa-times"></i>
        </div>
      </div>
    </div>
    <div class="row p-3">
      <div class="col">
        <p><strong>Inspection #:</strong> {{ inspection?.adasInspection }}</p>
        <p><strong>RO #:</strong> {{ inspection?.roNumber }}</p>
        <p><strong>Insurance:</strong> {{ inspection?.insuranceName }}</p>
        <p><strong>Status:</strong> {{ inspection?.status }}</p>
        <p><strong>Estimator:</strong> {{ inspection?.estimator }}</p>
        <p><strong>Estimate Source:</strong> {{ inspection?.estimateSource }}</p>
        <p v-if="isStatus"><strong>Change Status:</strong></p>
        <select v-if="isStatus" v-model="status" @change="saveStatus" class="form-control">
          <option v-for="item in statuses" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>
        <p v-if="isCompleted"><strong>Completed Date:</strong> {{ completedDate }}</p>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { lookupStore } from '@/stores/lookup'
import { inspectionStore } from '@/stores/inspection'
import globals from '@/plugins/globals'
export default {
  name: 'BlueprintRecord',
  props: {
    inspection: Object
  },
  emits: ['close'],
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(lookupStore, ['lookups']),
    name() {
      return 'popupDetails'
    },
    status() {
      let _status = null
      if (this.lookups['Status']) {
        let temp = this.lookups['Status'].find((item) => item.name === this.inspection.status)
        _status = temp ? temp.id : null
      }
      return _status
    },
    statuses() {
      let _data = []
      if (this.lookups['Status']) {
        const ids = [1, 2, 3, 4, 5]
        _data = this.lookups['Status'].filter((item) => ids.includes(item.id))
        _data = globals.sortArray(_data, 'name')
      }
      return _data
    },
    isStatus() {
      let _is = false
      if (this.inspection?.status) {
        if (!this.isCompleted) {
          _is = true
        }
      }
      return _is
    },
    isCompleted() {
      return this.inspection?.status === 'Complete'
    },
    completedDate() {
      let _date = ''
      if (this.inspection?.deliveryDate !== null) {
        _date = globals.formatDate(this.inspection.deliveryDate)
      }
      return _date
    }
  },
  methods: {
    ...mapActions(inspectionStore, ['setInspection', 'updateStatus']),
    closeDetails() {
      this.$emit('close')
    },
    async saveStatus() {
      let data = {
        adasInspection: this.inspection.adasInspection,
        status: this.status
      }
      await this.updateStatus(data)
    }
  }
}
</script>
<style scoped lang="scss">
.custom-record {
  position: absolute;
  top: 0;
  right: 0;
  width: 400px;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  z-index: 1000;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 3px;
}

.custom-header {
  position: relative;
  display: flex;
  background-color: #203535;
  color: white;
  border-bottom: 1px solid #dee2e6;
  border-radius: 3px;
  padding-top: 3px;
  padding-bottom: 3px;
  padding-left: 10px;
  padding-right: 10px;
  height: 38px;
}

.custom-close {
  position: absolute;
  right: 10px;
  top: 5px;

}

.custom-close-button {
  cursor: pointer;
}
</style>